import React from 'react';
import './OrderHeader.scss';
import { Icon, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import Button from 'Components/Shared/Button/Button';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import OrderCountDownContainer from 'Components/OrderCountDown/OrderCountDownContainer';
import OrderCancelConfirm from 'Components/OrderCancelConfirm/OrderCancelConfirm';

interface IProps {
  userName: string;
  imageUrl: string;
  isLoggedIn: boolean;
  isOrderPaid: boolean;
  onCancelOrderClick: () => void;
}

const OrderHeader: React.SFC<IProps> = ({
  userName,
  imageUrl,
  isLoggedIn,
  isOrderPaid,
  onCancelOrderClick,
}) => {

  const TooltipText = () => (
    <FormattedMessage 
      id='order.account.popover'
      defaultMessage={
        `Du är inloggad. Avbryt köpet om du vill 
        logga in som en annan användare.`
      }
      values={ { name: userName } }
    />
  );

  const Logo = () => (
    <div className='logo-container'>
      <img alt='Julius Biljettservice logga' src={ imageUrl } />
      <FormattedText 
        style='logo-text'
        displayName='Biljettköp - Tryggt och Säkert'
        formattedName='order.header.text'
      />
    </div>
  );

  const UserName = () => (
    isLoggedIn && userName && 
      <Tooltip placement='bottomRight' title={ TooltipText }>
        <div className='user-name'>
          <Icon type='user' /> { userName }
        </div>
      </Tooltip>
  );

  const CancelButton = () => (
    !isOrderPaid &&
      <OrderCancelConfirm 
        placement='bottomRight'
        triggerType='cancel-click' 
        onConfirm={ onCancelOrderClick } 
      >
        <Button 
          style='cancel-button' 
          color='transparent' 
          boxShadow={ false } 
          >
          <FormattedText 
            displayName='Avbryt köp'
            formattedName='order.header.cancel'
          />
        </Button>
      </OrderCancelConfirm>
  );

  const CountDown = () => (
    !isOrderPaid &&
      <OrderCountDownContainer />
  );

  return (
    <div className='order-header'>
      <Logo />
      <div className='order-info-container'>
        <UserName />
        <CountDown />
        <CancelButton />
      </div>
    </div>
  );
};

export default OrderHeader;


// WEBPACK FOOTER //
// ./src/components/OrderHeader/OrderHeader.tsx